import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CommonService } from '../../shared/services/common.service';
import { API_ENDPOINTS } from '../../core/services/api.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProfileServiceService {

  constructor(public commonSvc: CommonService, private http: HttpClient) { }

  getProfileData(data: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.PROFILE.USER_PROFILE, data)
  }
}
